import { action, observable, runInAction } from 'mobx';
import { priceListController } from './priceListController';
import {
  CreatePriceListRegionRequest,
  GetPriceListRegionRequest,
} from '../api/priceListApi';

// Полная позиция со всем строками
export interface PriceListRegion {
  id: string,
  fiasId: string,
  fiasAddress?: string,
  fiasLevel?: number,
}

export interface PriceListRegionsStore {
  priceListRegions: PriceListRegion[],
  priceListId: string,
  error: any,
  currentPriceListRegion: PriceListRegion,
}

export const priceListRegionsStore: PriceListRegionsStore = observable({
  priceListRegions: [],
  priceListId: null,
  error: null,
  currentPriceListRegion: null,
} as PriceListRegionsStore);

export const priceListRegionsActions = {
  getPriceListRegions: async (request: GetPriceListRegionRequest): Promise<void> => {
    const response = await priceListController.getPriceListRegions(request);
    priceListRegionsActions.handleError(response);
    runInAction(() => {
      priceListRegionsStore.priceListRegions = response.data;
    });
  },

  getPriceListRegionFromList: async (id: string): Promise<void> => {
    const response = priceListRegionsStore.priceListRegions.find((v) => v.id === id);
    priceListRegionsActions.setCurrentPriceListRegion(response || null);
  },

  createPriceListRegion: async (request: CreatePriceListRegionRequest): Promise<void> => {
    const response = await priceListController.createPriceListRegion(request);
    priceListRegionsActions.handleError(response);
  },

  deletePriceListRegion: async (id: string): Promise<void> => {
    const response = await priceListController.deletePriceListRegion(id);
    priceListRegionsActions.handleError(response);
  },

  clearCurrentPosition: action(() => {
    priceListRegionsStore.currentPriceListRegion = null;
  }),

  clearError: action(() => {
    priceListRegionsStore.error = null;
  }),

  handleError: action((response) => {
    if (response.errorData) {
      const { errorData } = response;
      priceListRegionsStore.error = errorData;
      throw errorData;
    }
  }),

  setCurrentPriceListRegion: action((priceListRegions: PriceListRegion) => {
     
    priceListRegionsStore.currentPriceListRegion = priceListRegions;
  }),
};
